import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the ServicesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-services',
  templateUrl: 'services.html',
})
export class ServicesPage {

  private ordersReadyToPickup = [];

  constructor(public navCtrl: NavController, public navParams: NavParams) {
    for (var i=0, t=8; i<t; i++) {
      this.ordersReadyToPickup.push(Math.round(Math.random() * 100))
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ServicesPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/services/services.ts